import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import FilterSelect from "component/common/FilterSelect";
import { Toast } from "utils/toast";
import ChartLoader from "component/common/ChartLoader";
import { getInventoryFlow } from "service/Dashboard";

import styles from "./InventoryFlow.module.scss";

const InventoryFlow = () => {
  let [inventory, setInventory] = useState({
    series: [
      {
        name: "Purchased",
        data: [],
      },
      {
        name: "Received",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        stacked: true,
        redrawOnWindowResize: true,
        redrawOnParentResize: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ["#96C0FF", "#3C5877"],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 5,
          columnWidth: "25%",
          barHeight: "100%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      yaxis: {
        title: {
          text: "No. of Products",
          style: {
            fontSize: "14px",
            color: "#999999",
          },
        },
      },
      xaxis: {
        type: "category",
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetY: 0,
        offsetX: 0,
        fontSize: "14px",
        fontFamily: "Helvetica, Arial",
        fontWeight: 600,
        labels: {
          colors: "#151522",
          useSeriesColors: false,
        },
        markers: {
          width: 15,
          height: 15,
          strokeWidth: 0,
          strokeColor: "#fff",
          radius: 12,
          offsetX: "-5px",
          offsetY: "2px",
        },
        itemMargin: {
          horizontal: 10,
          vertical: 5,
        },
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: false,
        },
      },
    },
  });

  let [loading, setLoading] = useState(true);

  let [year, setYear] = useState(2021);

  const yearOptions = [2021];

  useEffect(() => {
    setLoading(true);
    getInventory();
  }, [year]);

  const getInventory = async () => {
    try {
      let response = await getInventoryFlow({ year: year });
      if (response.status == 200) {
        let receivedData = Array(new Date().getMonth() + 1)
          .fill(0)
          .concat(Array(12 - (new Date().getMonth() + 1)).fill(null));
        response.data.data.Received.map((list) => {
          receivedData[list._id - 1] = list.number;
          return null;
        });
        let purchasedData = Array(new Date().getMonth() + 1)
          .fill(0)
          .concat(Array(12 - (new Date().getMonth() + 1)).fill(null));
        response.data.data.Purchased.map((list) => {
          purchasedData[list._id - 1] = list.Revenue;
          return null;
        });
        let inventoryChart = inventory;
        inventoryChart.series[0].data = purchasedData;
        inventoryChart.series[1].data = receivedData;
        setInventory(inventoryChart);
        setLoading(false);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <div className="col-md-6">
      <div className={styles.inventory_chart}>
        <div className={styles.inventory_chart_title}>
          <b>Inventory Flow</b>
          <div style={{ width: "100px" }}>
            <FilterSelect
              options={yearOptions}
              value={year}
              onChange={(e) => setYear(e.value)}
            />
          </div>
        </div>
        {loading ? (
          <ChartLoader />
        ) : (
          <ReactApexChart
            options={inventory.options}
            series={inventory.series}
            type="bar"
            height={300}
          />
        )}
      </div>
    </div>
  );
};

export default InventoryFlow;
